(function () {
  function initSlider(root) {
    if (!root || root.dataset.dfReady === 'true') return;

    const slides = Array.from(root.querySelectorAll('[data-df-slide]'));
    const dots = Array.from(root.querySelectorAll('[data-df-dot]'));
    if (slides.length < 2) return;

    root.dataset.dfReady = 'true';

    let index = slides.findIndex((slide) => slide.classList.contains('is-active'));
    if (index < 0) index = 0;

    const autoplay = root.dataset.autoplay === 'true';
    const speed = Math.max(3, Number(root.dataset.speed) || 5) * 1000;
    const reduceMotion = window.matchMedia('(prefers-reduced-motion: reduce)').matches;
    let timer = null;
    let touchStartX = 0;
    let touchDeltaX = 0;

    function goTo(nextIndex) {
      index = (nextIndex + slides.length) % slides.length;

      slides.forEach((slide, i) => {
        const active = i === index;
        slide.classList.toggle('is-active', active);
        slide.setAttribute('aria-hidden', active ? 'false' : 'true');
      });

      dots.forEach((dot, i) => {
        const active = i === index;
        dot.classList.toggle('is-active', active);
        dot.setAttribute('aria-selected', active ? 'true' : 'false');
      });
    }

    function next() {
      goTo(index + 1);
    }

    function startAutoplay() {
      stopAutoplay();
      if (!autoplay || reduceMotion) return;
      timer = window.setInterval(next, speed);
    }

    function stopAutoplay() {
      if (timer) {
        window.clearInterval(timer);
        timer = null;
      }
    }

    dots.forEach((dot) => {
      dot.addEventListener('click', () => {
        goTo(Number(dot.dataset.index) || 0);
        startAutoplay();
      });
    });

    root.addEventListener(
      'touchstart',
      (event) => {
        touchStartX = event.changedTouches[0].screenX;
        touchDeltaX = 0;
        stopAutoplay();
      },
      { passive: true }
    );

    root.addEventListener(
      'touchmove',
      (event) => {
        touchDeltaX = event.changedTouches[0].screenX - touchStartX;
      },
      { passive: true }
    );

    root.addEventListener(
      'touchend',
      () => {
        if (Math.abs(touchDeltaX) > 40) {
          goTo(touchDeltaX < 0 ? index + 1 : index - 1);
        }
        startAutoplay();
      },
      { passive: true }
    );

    root.addEventListener('mouseenter', stopAutoplay);
    root.addEventListener('mouseleave', startAutoplay);
    root.addEventListener('focusin', stopAutoplay);
    root.addEventListener('focusout', startAutoplay);

    goTo(index);
    startAutoplay();
  }

  function initAll() {
    document.querySelectorAll('[data-df-slider]').forEach(initSlider);
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', initAll);
  } else {
    initAll();
  }

  document.addEventListener('shopify:section:load', (event) => {
    const slider = event.target.querySelector('[data-df-slider]');
    if (slider) {
      delete slider.dataset.dfReady;
      initSlider(slider);
    }
  });
})();
